export default "__VITE_PUBLIC_ASSET__1dd1e0a3__"